/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreatePartnerDtoGen,
  MrfiktivGeojsonPointViewmodelGen,
  MrfiktivMultipleIdsDtoGen,
  MrfiktivMultiplePartnersFindManyIdsGen,
  MrfiktivPageViewModelGen,
  MrfiktivPartnerControllerFindAllPaginatedParamsGen,
  MrfiktivPartnerControllerFindAllParamsGen,
  MrfiktivPartnerControllerFindByNameGeocodeParamsGen,
  MrfiktivPartnerControllerFindByNameQueryParamsGen,
  MrfiktivPartnerControllerFindByUrlParamsGen,
  MrfiktivPartnerControllerGetGeocodeParamsGen,
  MrfiktivPartnerDocumentGen,
  MrfiktivPartnerGeojsonViewmodelGen,
  MrfiktivPartnerViewModelGen,
  MrfiktivUpdatePartnerCompanyUserNameGen,
  MrfiktivUpdatePartnerDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Partner<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerCreate
   * @summary Create a new partner
   * @request POST:/partner
   * @secure
   * @response `200` `MrfiktivPartnerViewModelGen` The record has been successfully created
   * @response `403` `void` Forbidden.
   */
  partnerControllerCreate = (data: MrfiktivCreatePartnerDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPartnerViewModelGen, void>({
      path: `/partner`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerFindAll
   * @summary Deprecated: Get all partners. Use GET /partner/page instead
   * @request GET:/partner
   * @deprecated
   * @secure
   * @response `200` `(MrfiktivPartnerViewModelGen)[]` The found record
   * @response `403` `void` Forbidden.
   */
  partnerControllerFindAll = (query: MrfiktivPartnerControllerFindAllParamsGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPartnerViewModelGen[], void>({
      path: `/partner`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerGetMany
   * @summary Get many partners by id
   * @request POST:/partner/getByIds
   * @secure
   * @response `200` `(MrfiktivPartnerViewModelGen)[]` The found record
   * @response `403` `void` Forbidden.
   */
  partnerControllerGetMany = (data: MrfiktivMultipleIdsDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPartnerViewModelGen[], void>({
      path: `/partner/getByIds`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerFindAllPartnersForAnalyticsPermission
   * @summary Get partners for analytics permission
   * @request POST:/partner/byAnalyticsPermissionIds
   * @secure
   * @response `200` `(MrfiktivPartnerDocumentGen)[]` The found record
   * @response `403` `void` Forbidden.
   */
  partnerControllerFindAllPartnersForAnalyticsPermission = (
    data: MrfiktivMultiplePartnersFindManyIdsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerDocumentGen[], void>({
      path: `/partner/byAnalyticsPermissionIds`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerFindGeojson
   * @summary Get all partners
   * @request GET:/partner/geojson
   * @secure
   * @response `200` `MrfiktivPartnerGeojsonViewmodelGen` The found record
   * @response `403` `void` Forbidden.
   */
  partnerControllerFindGeojson = (params: RequestParams = {}) =>
    this.http.request<MrfiktivPartnerGeojsonViewmodelGen, void>({
      path: `/partner/geojson`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerFindByNameQuery
   * @summary Get a partner by name
   * @request GET:/partner/byName
   * @response `200` `MrfiktivPartnerViewModelGen` The found record
   * @response `403` `void` Forbidden.
   */
  partnerControllerFindByNameQuery = (
    query: MrfiktivPartnerControllerFindByNameQueryParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerViewModelGen, void>({
      path: `/partner/byName`,
      method: "GET",
      query: query,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerFindByUrl
   * @summary Get a partner by url
   * @request GET:/partner/byUrl
   * @response `200` `MrfiktivPartnerViewModelGen` The found record
   * @response `400` `void` Bad request
   * @response `404` `void` No partner with that url was found
   */
  partnerControllerFindByUrl = (query: MrfiktivPartnerControllerFindByUrlParamsGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPartnerViewModelGen, void>({
      path: `/partner/byUrl`,
      method: "GET",
      query: query,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerFindByNameGeocode
   * @summary Get a partner by location search string
   * @request GET:/partner/byLocation
   * @secure
   * @response `200` `MrfiktivPartnerViewModelGen` The found record
   * @response `403` `void` Forbidden.
   */
  partnerControllerFindByNameGeocode = (
    query: MrfiktivPartnerControllerFindByNameGeocodeParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerViewModelGen, void>({
      path: `/partner/byLocation`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerGetGeocode
   * @summary Gets the geocode for an address.
   * @request GET:/partner/geocodehelper
   * @secure
   * @response `200` `MrfiktivGeojsonPointViewmodelGen` The found record
   * @response `403` `void` Forbidden.
   */
  partnerControllerGetGeocode = (query: MrfiktivPartnerControllerGetGeocodeParamsGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivGeojsonPointViewmodelGen, void>({
      path: `/partner/geocodehelper`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerFindAllPaginated
   * @summary (ADMIN) Get all partners using pagination
   * @request GET:/partner/page
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivPartnerViewModelGen)[] })`
   * @response `403` `void` Forbidden.
   */
  partnerControllerFindAllPaginated = (
    query: MrfiktivPartnerControllerFindAllPaginatedParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivPartnerViewModelGen[] }, void>({
      path: `/partner/page`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerFindOne
   * @summary Get an partner by id
   * @request GET:/partner/{id}
   * @response `200` `MrfiktivPartnerViewModelGen` The found record
   * @response `403` `void` Forbidden.
   */
  partnerControllerFindOne = (id: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivPartnerViewModelGen, void>({
      path: `/partner/${id}`,
      method: "GET",
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerUpdate
   * @summary Update a partner by id
   * @request PATCH:/partner/{id}
   * @secure
   * @response `200` `MrfiktivPartnerViewModelGen` The updated record
   * @response `403` `void` Forbidden.
   */
  partnerControllerUpdate = (id: string, data: MrfiktivUpdatePartnerDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPartnerViewModelGen, void>({
      path: `/partner/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerRemove
   * @summary Delete a partner by id
   * @request DELETE:/partner/{id}
   * @secure
   * @response `200` `MrfiktivPartnerViewModelGen` The deleted record
   * @response `403` `void` Forbidden.
   */
  partnerControllerRemove = (id: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivPartnerViewModelGen, void>({
      path: `/partner/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerFindByName
   * @summary Deprecated: Get a partner by name
   * @request GET:/partner/{partnerName}/byName
   * @deprecated
   * @response `200` `MrfiktivPartnerViewModelGen` The found record
   * @response `403` `void` Forbidden.
   */
  partnerControllerFindByName = (partnerName: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivPartnerViewModelGen, void>({
      path: `/partner/${partnerName}/byName`,
      method: "GET",
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner
   * @name PartnerControllerUpdatePartnerCompanyUserName
   * @summary Update partners companyUsername
   * @request PATCH:/partner/{id}/username
   * @secure
   * @response `200` `MrfiktivPartnerViewModelGen` The record has been successfully updated
   * @response `403` `void` Forbidden.
   */
  partnerControllerUpdatePartnerCompanyUserName = (
    id: string,
    data: MrfiktivUpdatePartnerCompanyUserNameGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerViewModelGen, void>({
      path: `/partner/${id}/username`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
